import { render, staticRenderFns } from "./SalesIcon.vue?vue&type=template&id=6a8b8a08&scoped=true&"
import script from "./SalesIcon.vue?vue&type=script&lang=ts&"
export * from "./SalesIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SalesIcon.vue?vue&type=style&index=0&id=6a8b8a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b8a08",
  null
  
)

export default component.exports